import { Provider } from '@angular/core';
import { RepairsFirestoreStore } from './repairs-firestore-store.service';
import { RepairsMockStore } from './repairs-mock-store.service';
import { REPAIRS_STORE, resolveRepairsStoreMode } from './repairs-store.interface';

export function provideRepairsStore(): Provider[] {
  return [
    RepairsMockStore,
    RepairsFirestoreStore,
    {
      provide: REPAIRS_STORE,
      useFactory: (mock: RepairsMockStore, firestore: RepairsFirestoreStore) =>
        resolveRepairsStoreMode() === 'mock' ? mock : firestore,
      deps: [RepairsMockStore, RepairsFirestoreStore]
    }
  ];
}
